import React, {Component} from 'react'
import {Button} from "antd";
import AddBrandsPopup from "./AddBrandsPopup";


class ButtonAddBrands extends Component {
    state = {
        isOpen: false,
    }

    _handleTogglePopup = () => {
        this.setState({
            isOpen: !this.state.isOpen
        })
    }

    _handleAddBrands = () => {
        this.props.onAddBrand()
    }

    render() {
        const {isOpen} = this.state

        return(
            <div className="AddBrandNew">
                <Button className="add-button btn btn-primary" style={{height: 36}} onClick={this._handleTogglePopup}>Add brand</Button>

                <AddBrandsPopup isOpen={isOpen} onTogglePopup={this._handleTogglePopup} onAddBrand={this._handleAddBrands}/>
            </div>
        )
    }
}

export default ButtonAddBrands